import { faEye } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import BackButton from "../common/backButton";
import Footer from "../common/components/Footer";
import Header from "../common/components/ui/Header";
import consts from "../consts";

function CreateUser() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    confirm_password: "",
  });
  const [passwordShown, setPasswordShown] = useState(false);

  const onSubmit = (values) => {
    // values.preventDefault()
    if (values.password !== values.confirm_password) {
      return toast.warning("As senhas devem ser iguais!");
    }
    const loginForm = {
      username: values.email,
      password: values.password,
      name: values.name,
      email: values.email,
    };
    axios
      .post(`${consts.API_URL}/auth/signup`, loginForm)
      .then((resp) => {
        toast.success("Cadastro realizado!");
      })
      .catch((e) => {
        toast.error(e);
      });
  };

  const changeForm = (e) => {
    const { name, value } = e.target;

    setForm({ ...form, [name]: value });
  };

  return (
    <div className="min-h-screen dark:bg-[#121212] dark:text-white">
      <div className="container h-full mx-auto">
        <div className="flex">
          <BackButton path="usuarios" text="Voltar" />
        </div>
        <Header text={"Criar Usuário"} />
        <div className="flex justify-center mt-6 mb-8 bg-gray-300">
          <div className="flex flex-col gap-2">
            <span className="self-start font-semibold mt-3">Nome</span>
            <input
              className="p-3 mb-3 text-black outline-none border-gray-800 border w-96 b-gray-100 rounded-xl"
              name="name"
              type="text"
              onChange={changeForm}
            />
            <span className="self-start font-semibold">E-mail</span>
            <input
              className="p-3 mb-3 text-black outline-none border-gray-800 border w-96 b-gray-100 rounded-xl"
              name="email"
              type="text"
              onChange={changeForm}
            />
            <span className="self-start font-semibold">Senha</span>
            <div className="flex gap-2">
              <input
                className="p-3 mb-3 text-black outline-none border-gray-800 border w-96 b-gray-100 rounded-xl"
                name="password"
                type={passwordShown ? "text" : "password"}
                onChange={changeForm}
              />
              <button
                onMouseEnter={() => setPasswordShown(true)}
                onMouseLeave={() => setPasswordShown(false)}
                className="px-4 py-2 text-black bg-gray-200 rounded-xl hover:bg-gray-300"
              >
                <FontAwesomeIcon icon={faEye} />
              </button>
            </div>
            <span className="self-start font-semibold">Confirmar Senha</span>

            <div className="flex gap-2">
              <input
                className="p-3 mb-3 text-black outline-none border-gray-800 border w-96 b-gray-100 rounded-xl"
                name="confirm_password"
                type={passwordShown ? "text" : "password"}
                onChange={changeForm}
              />
              <button
                onMouseEnter={() => setPasswordShown(true)}
                onMouseLeave={() => setPasswordShown(false)}
                className="px-4 py-2 text-black bg-gray-200 rounded-xl hover:bg-gray-300"
              >
                <FontAwesomeIcon icon={faEye} />
              </button>
            </div>
            <button
              onClick={() => onSubmit(form)}
              className="p-3 mt-3 bg-[#53D769] rounded-xl w-96 hover:bg-[#46C263] dark:text-black font-semibold"
            >
              Confirmar
            </button>
            <button className="p-3 mt-3 mb-5 font-semibold bg-gray-400 hover:bg-gray-500 rounded-xl w-96 dark:text-white">
              Cancelar
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CreateUser;
